import { Content, AnswerOptionsContent } from "./Content"
import { Teaser } from "./Teaser"

export class ContentData extends Content {
  notification!: Content
  cheatSheet!: Content
  teaser?: Teaser
  answers!: Array<AnswerOptionsContent>
}
